import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { RestrictionCheck, useRestricted } from '@procureai/permissions-ui';
import { Fragment, ReactNode, useMemo } from 'react';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { NBSP } from '~/common/constants';
import { DataGridLink, DataGridLinkProps } from '~/components/DataGridCustom';

export type LinkCellValue = Union.Nullable<{
  label: ReactNode;
  to: DataGridLinkProps['to'];
  variant?: DataGridLinkProps['variant'];
  target?: DataGridLinkProps['target'];
}>;

interface LinkCellProps<R extends GridValidRowModel = any> {
  value: LinkCellValue | LinkCellValue[];
  row: R;
  needs?: RestrictionCheck;
}

export const LinkCell = <R extends GridValidRowModel = any>({ value: valueProp, needs }: LinkCellProps<R>) => {
  const isAllowed = useRestricted(needs);
  const values: LinkCellProps<R>['value'] = useMemo(() => {
    if (valueProp) {
      return Array.isArray(valueProp) ? valueProp : [valueProp];
    }
    return null;
  }, [valueProp]);

  if (values) {
    const result = values
      .map((value, index) => {
        if (value) {
          // const linkProps = linkPropsGetter(value, row);
          return (
            <Fragment key={index}>
              {index > 0 ? `,${NBSP}` : null}
              {isAllowed ? <DataGridLink {...value}>{value.label}</DataGridLink> : value.label}
            </Fragment>
          );
        }
        return null;
      })
      .filter(Boolean);

    return result.length ? <>{result}</> : null;
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
